import { put, takeLatest } from 'redux-saga/effects';
import { createAppTableSaga, createAppTableStore } from 'components/AppTable/store';
import apiRoutes from 'config/apiRoute';
import { convertMinsToHrsMins } from 'utils/string.utils';
import { toTimeEntriesParams } from 'services/timeTracking/tableParams';

export const requestTimelogSlice = createAppTableStore({
  name: 'requestTimelog' as const,
  url: apiRoutes.TIME_ENTRIES,
  initialState: {
    apiParamsHandler: toTimeEntriesParams,
    totalTime: null as null | string,
  },
  reducers: {
    setTotalTime: (state, { payload }: { payload: string; type: string }) => {
      return {
        ...state,
        totalTime: payload,
      };
    },
  },
});

function* handleApiResponseSagaListener({ payload }: { payload: any }) {
  yield put(requestTimelogSlice.actions.setTotalTime(convertMinsToHrsMins(Number(payload?.meta?.total_minutes ?? 0))));
}

export const requestTimelogSaga = createAppTableSaga(requestTimelogSlice, function* customGenerator() {
  yield takeLatest(requestTimelogSlice.actions.handleApiResponse, handleApiResponseSagaListener);
});

export const requestTimelogReducer = requestTimelogSlice.reducer;
